import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-28806b68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "forms-wrapper"
};
const _hoisted_2 = {
  class: "section"
};
const _hoisted_3 = {
  class: "checkbox-wrapper"
};
const _hoisted_4 = {
  class: "section"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Choose the timeline", -1));
const _hoisted_6 = {
  class: "checkbox-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_button = _resolveComponent("b-button");
  const _component_FilterSectionHeader = _resolveComponent("FilterSectionHeader");
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
  const _component_b_form_radio = _resolveComponent("b-form-radio");
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_FilterSectionHeader, {
    noRuler: "",
    header: 'Select Pages to include in report',
    headerStyle: {
      color: '#000000',
      fontSize: '16px',
      padding: 0
    },
    onClick: _cache[1] || (_cache[1] = e => _ctx.$emit('clearAll', e)),
    disable: $options.disableClear
  }, {
    "extra-buttons": _withCtx(() => [_createVNode(_component_b_button, {
      variant: "outline-secondary",
      class: "tiny-btn",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('selectAll'))
    }, {
      default: _withCtx(() => [_createTextVNode(" Select All ")]),
      _: 1
    })]),
    _: 1
  }, 8, ["disable"]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pages, (page, key) => {
    return _openBlock(), _createBlock(_component_b_form_checkbox, {
      class: "custom-checkbox",
      key: page,
      checked: $props.selectedPages[key] ? $props.selectedPages[key] : false,
      onChange: $event => _ctx.$emit('pageSelect', {
        key,
        page
      }),
      value: page.item
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(page.item), 1)]),
      _: 2
    }, 1032, ["checked", "onChange", "value"]);
  }), 128))])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createVNode(_component_b_form_radio_group, {
    class: "radio-group",
    checked: $props.selectedPeriod
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.periods, period => {
      return _openBlock(), _createBlock(_component_b_form_radio, {
        class: "custom-radio",
        onChange: $event => _ctx.$emit('periodSelect', period),
        key: period,
        value: period.item
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(period.value), 1)]),
        _: 2
      }, 1032, ["onChange", "value"]);
    }), 128))]),
    _: 1
  }, 8, ["checked"])])])]);
}